// extracted by mini-css-extract-plugin
export default {"contentContainer":"content_contentContainer__peW0n","contentContainer--expanded":"content_contentContainer--expanded__eC8ef","content":"content_content__XVg+T"};